export type ApplicationScope = "internal" | "external";
export type AuthScope = "internal" | "external" | "external-employer";

export type KeycloakRole = "internal-portal-user" | "portal-user";

export const AUTO_UX_PHONE_NUMBER = "1800 288 689";
export const AUTO_UX_CORPORATE_SUPPORT_PHONE_NUMBER = "(02) 9424 1216";
export const AUTO_UX_SUPPORT_BIO =
  "Our Experience Team is here to help you have the best novated leasing experience on the planet.";
